import cabecalho from '@/components/global/Cabecalho/Cabecalho.vue'
import menuLateral from '@/components/global/MenuLateral/MenuLateral.vue'
import spinnerProcessando from '@/components/layout/spinnerProcessamento/SpinnerProcessamento.vue'
import { BSpinner, BToast } from 'bootstrap-vue'
import defaultTable from '@/components/layout/defaultTable/DefaultTable.vue'
import util from '@/util'
import mensagens from '@/util/mensagens'

export default {
  name: 'modal-verifica-cancelamento',
  components: {
    cabecalho,
    menuLateral,
    spinnerProcessando,
    'b-toast': BToast,
    'default-table': defaultTable,
    'b-spinner': BSpinner
  },
  computed: {},
  data: () => {
    return {
      aceitou: false,
      contrato: null,
      produto_nome: null,
      modal_verifica_cancelamento: {
        principal: '0',
        mensagem: null,
        contrato_id: null,
        aceitou: false,
        loading: false
      }
    }
  },
  props: ['modalCancelamento', 'resumoContrato', 'isVencido'],
  mounted () {},
  methods: {
    alterarPlano () {
      this.$router.push({ name: 'alterar-plano-contrato' })
    },
    abrirModalVerificaCancelamento (id, principal = '0', data) {
      this.modal_verifica_cancelamento.mensagem = null
      this.modal_verifica_cancelamento.aceitou = false
      this.modal_verifica_cancelamento.principal = principal

      this.contrato = data
      this.produto_nome = data.produto_nome

      this.modal_verifica_cancelamento.contrato_id = id
      this.$refs.modal_verifica_cancelamento.show()
    },
    async verificarCancelamento (id) {
      this.modal_verifica_cancelamento.aceitou = true
      this.modal_verifica_cancelamento.loading = true
      try {
        const resposta = await this.axios.post(`/manager/conta/contrato/verifica/cancelamento`, { contrato_id: id })
        if (resposta.data.retorno.sucesso) {
          util.criarAlertaToastDeSucesso(this, 'Aviso', resposta.data.retorno.mensagem)
          this.$refs.modal_verifica_cancelamento.hide()
          this.modalCancelamento.abrirModal(resposta.data.retorno.listaDados.token, resposta.data.retorno.listaDados.principal, { contrato: this.contrato, id_contrato: id })
        } else {
          util.criarAlertaToastDeErro(this, 'Aviso', resposta.data.retorno.mensagem)
          this.$refs.modal_verifica_cancelamento.hide()
        }
      } catch (e) {
        if (e.response.status === 400) {
          util.criarAlertaToastDeErro(this, 'Aviso', e.response.data.retorno.mensagem)
        } else {
          util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
        }
        this.modal_verifica_cancelamento.aceitou = false
      }
      this.modal_verifica_cancelamento.loading = false
    }
  }
}
